import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-control",
  "use": "icon-control-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-control\"><path d=\"M186.88 384c23.04 74.24 89.6 128 171.52 128s148.48-53.76 171.52-128H870.4c28.16 0 51.2-23.04 51.2-51.2s-23.04-51.2-51.2-51.2H529.92c-23.04-74.24-89.6-128-171.52-128s-148.48 53.76-171.52 128H128c-28.16 0-51.2 23.04-51.2 51.2s23.04 51.2 51.2 51.2h58.88z m171.52-128c43.52 0 76.8 33.28 76.8 76.8s-33.28 76.8-76.8 76.8-76.8-33.28-76.8-76.8 33.28-76.8 76.8-76.8zM896 640h-58.88c-23.04-74.24-89.6-128-171.52-128s-148.48 53.76-171.52 128H153.6c-28.16 0-51.2 23.04-51.2 51.2s23.04 51.2 51.2 51.2h340.48c23.04 74.24 89.6 128 171.52 128s148.48-53.76 171.52-128H896c28.16 0 51.2-23.04 51.2-51.2s-23.04-51.2-51.2-51.2z m-230.4 128c-43.52 0-76.8-33.28-76.8-76.8s33.28-76.8 76.8-76.8 76.8 33.28 76.8 76.8-33.28 76.8-76.8 76.8z\" p-id=\"2415\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/control.svg
// module id = oiHZ
// module chunks = 42